import { lazy, type ReactNode } from 'react';

import classNames from 'classnames';

import styles from './ChampionsTournamentSmallWidget.module.scss';

const TrophyIcon = lazy(() => import('../../../../../components/SVGIcons/TrophyIcon'));

interface ChampionsTournamentSmallWidgetProps {
  widgetImageUrl?: string;
  positionValue: string | null;
  startsInLabel?: string;
  showEmptyPositionBar?: boolean;
  timer?: ReactNode;
}

export function ChampionsTournamentSmallWidget(props: ChampionsTournamentSmallWidgetProps) {
  const { widgetImageUrl, positionValue, startsInLabel, showEmptyPositionBar, timer } = props;
  const hasPosition = positionValue != null;
  const hasStartsInLabel = !hasPosition && startsInLabel != null;
  const hasEmptyPositionBar = !hasPosition && !hasStartsInLabel && showEmptyPositionBar === true;
  const hasBadge = hasPosition || hasStartsInLabel || hasEmptyPositionBar;
  const hasTimer = timer != null;
  const hasFooter = hasBadge || hasTimer;

  return (
    <div className={styles.container}>
      {widgetImageUrl ? (
        <img alt="" className={styles.img} src={widgetImageUrl} />
      ) : (
        <TrophyIcon className={styles.img} />
      )}
      {hasFooter && (
        <div className={classNames(styles.content, !hasBadge && styles.noBadgeContent)}>
          {hasPosition && (
            <div className={styles.positionContainer}>
              <span className={styles.positionText}>{positionValue}</span>
            </div>
          )}
          {hasStartsInLabel && (
            <div className={styles.startsInContainer}>
              <span className={styles.startsInText}>{startsInLabel}</span>
            </div>
          )}
          {hasEmptyPositionBar && <div className={styles.positionContainer} />}
          {hasTimer && (
            <div className={classNames(styles.timerContainer, !hasBadge && styles.noBadgeTimerContainer)}>{timer}</div>
          )}
        </div>
      )}
    </div>
  );
}
